<template>
  <div class="app-container">
    <hear></hear>
    <!-- <el-image :preview-src-list="srcList
    style="width: 100px; height: 100px"
    :src="url" 
    ">
  </el-image> -->
    <div class="backoff">
      <div>
        <el-button @click="jeibao" v-if="shenqingInfo.state == 2" class="anniu"
          >解保</el-button
        >
        <!--  -->
        <el-button v-if="shenqingInfo.state == 2" @click="xubao" class="anniu"
          >续保</el-button
        >
        <!--放弃保函  和上面的不兼容  支付之前叫做放弃保函     -->
        <el-button
          v-if="shenqingInfo.state == 1 || shenqingInfo.state == 0"
          class="anniu"
          @click="fanqi"
          >放弃保函</el-button
        >
        <el-button class="anniu" @click="$router.go(-1)">返回</el-button>
      </div>
    </div>
    <el-tabs style="flex:1;" class="tac" tab-position="left">
      <el-tab-pane style="height: 100%" label="保函信息">
        <!-- {{shenqingInfo}} -->
        <el-form
          :model="shenqingInfo"
          label-width="170px"
          :disabled="true"
          class="fromsBox"
        >
          <el-form-item label="申请编号 :">
            <el-input
              v-model="shenqingInfo.apply_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="保函编号 :">
            <el-input
              v-model="shenqingInfo.guarantee_apply_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item label="标段编号 :">
            <el-input
              v-model="shenqingInfo.bidding_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="标段名称 :">
            <el-input
              v-model="shenqingInfo.bidding_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="开标时间 :">
            <el-input
              :value="shenqingInfo.create_time | dateFormat"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="项目总额 :">
            <el-input
              v-model="shenqingInfo.guarantee_company_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="保费金额 :">
            <el-input
              v-model="shenqingInfo.margin_amount"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="保函状态 :">
            <!-- "state": 2, //保函状态，0：申请中，1：审核中，2：审核通过，3：审核不通过 -->
            <el-input
              v-show="shenqingInfo.state == 0"
              value="申请中"
              autocomplete="off"
            ></el-input>
            <el-input
              v-show="shenqingInfo.state == 1"
              value="审核中"
              autocomplete="off"
            ></el-input>
            <el-input
              v-show="shenqingInfo.state == 2"
              value="审核通过"
              autocomplete="off"
            ></el-input>
            <el-input
              v-show="shenqingInfo.state == 3"
              value="审核不通过"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="申请文件">
        <!-- <el-form :model="shenpiFile" label-width="170px" :disabled="true" class="fromsBox">
                    <div v-for="item in shenqishenpiFilengInfo" :key=item>
                        <el-form-item label="文件名称 :">
                            <el-input :value="item.filename" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="记录时间 :">
                            <el-input v-if="item.createtime==null" value="" autocomplete="off"></el-input>
                            <el-input v-else :value="item.createtime | dateFormat" autocomplete="off"></el-input>
                        </el-form-item>
                        <el-form-item label="文件 :">
                            <img width="49%" height="128" :src="$baseUrl + item.filepath" alt />
                        </el-form-item>
                    </div>

                </el-form> -->
        <div style="padding: 0 1%" class="fromsBox">
          <div
            v-for="item in shenqishenpiFilengInfo"
            :key="item"
            class="public-kuang"
          >
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img src="@/assets/imges/pdf.png" alt="" srcset="" class="pdf" />
            </div>
            <div style="display: flex; flex-direction: column; flex: 1">
              <div
                style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div class="kuang-txt">
                  <div class="kuang-1">{{ item.filename }}</div>
                </div>
                <!---->
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div @click="yulan(item.filepath)" class="kuang-2">
                      预览
                    </div>
                    <div
                      class="kuang-2"
                      @click="xiazai"
                      style="margin-left: 10px"
                    >
                      下载
                    </div>
                  </div>
                </div>
                <!---->
              </div>
              <div style="margin-top: 5px; margin-left: 1.25rem">
                <!-- <div>保函文件：{{item.filepath}}</div> -->
                <div>
                  下载地址：<a
                    target="_blank"
                    :href="$baseUrl + item.filepath"
                    >{{
                      item.filepath == null ? "" : $baseUrl + item.filepath
                    }}</a
                  >
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="保函资料">
        <div style="padding: 0 1%" class="fromsBox">
          <div v-for="item in baohanFile" :key="item" class="public-kuang">
            <div
              style="
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <img src="@/assets/imges/pdf.png" alt="" srcset="" class="pdf" />
            </div>
            <div style="display: flex; flex-direction: column; flex: 1">
              <div
                style="
                  display: flex;

                  justify-content: space-between;
                  align-items: center;
                "
              >
                <div class="kuang-txt">
                  <div class="kuang-1">{{ item.filename }}</div>
                </div>
                <!---->
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    "
                  >
                    <div @click="yulan(item.qz_file)" class="kuang-2">
                      预览
                    </div>
                    <div
                      class="kuang-2"
                      @click="xiazai"
                      style="margin-left: 10px"
                    >
                      下载
                    </div>
                  </div>
                </div>
                <!---->
              </div>
              <div style="margin-top: 5px; margin-left: 1.25rem">
                <!-- <div>保函文件：{{item.filepath}}</div> -->
                <div>
                  下载地址：<a
                    target="_blank"
                    :href="$baseUrl + item.qz_file"
                    >{{
                      item.qz_file == null ? "" : $baseUrl + item.qz_file
                    }}</a
                  >
                </div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="施工单位">
        <el-form
          :model="formLabelAlign"
          label-width="170px"
          :disabled="true"
          class="fromsBox"
        >
          <el-form-item label="申请公司名称 :">
            <el-input
              v-model="formLabelAlign.company_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item label="法人姓名 :">
            <el-input
              v-model="formLabelAlign.corporate_information"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人联系方式 :">
            <el-input
              v-model="formLabelAlign.corporate_phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证号 :">
            <el-input
              v-model="formLabelAlign.corporate_id_number"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人身份证 :">
            <el-image :preview-src-list="[$baseUrl + formLabelAlign.id_card_front]"

              :src="$baseUrl + formLabelAlign.id_card_front"
              alt
              style=" width:49%;height:100%"
            />
            <el-image :preview-src-list="[$baseUrl + formLabelAlign.id_card_reverse]"
              width="49%"
              height="128"
              :src="$baseUrl + formLabelAlign.id_card_reverse"
              alt
              style=" width:49%;height:100%"
            />
          </el-form-item>
          <el-form-item label="统一社会信用代码 :">
            <el-input
              v-model="formLabelAlign.unify_social_credit_code"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业性质 :">
            <el-input
              :value="formLabelAlign.guarantee_company_type"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="企业地址 :">
            <el-input
              v-model="formLabelAlign.contact_address"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="开户行 :">
            <el-input
              v-model="formLabelAlign.account_bank"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="账户 :">
            <el-input
              v-model="formLabelAlign.basic_account"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="联行号 :">
            <el-input value="" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="营业执照 :">
            <el-image :preview-src-list="[$baseUrl + formLabelAlign.business_license_pic]"
            
              :src="$baseUrl + formLabelAlign.business_license_pic"
              alt
              style=" width:100%;height:100%"
            />
            <!-- <img
              width="49%"
              height="128"
              style="height:100%;width: 100%;"
              :src=""
              alt
            /> -->
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="出函机构">
        <el-form
          :model="chjg"
          label-width="170px"
          :disabled="true"
          class="fromsBox"
        >
          <el-form-item label="公司名称 :">
            <el-input
              v-model="chjg.guarantee_company_name"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="法人姓名 :">
            <el-input v-model="chjg.username" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="法人联系方式 :">
            <el-input v-model="chjg.mobile" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码 :">
            <el-input v-model="chjg.unify_code" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司类型 :">
            <el-input
              :value="chjg.guarantee_company_type"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址 :">
            <el-input v-model="chjg.address" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="开户行 :">
            <el-input v-model="chjg.bankname" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="账户 :">
            <el-input v-model="chjg.bankcode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="联行号 :">
            <el-input value="" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="费率 :">
            <el-input
              v-model="chjg.guarantee_company_rate"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照 :">
            <img
              width="49%"
              height="128"
              style="height:100%;width: 100%;"
              :src="chjg.business_license_pic"
              alt
            />
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="支付记录">
        <el-table
      :data="tableData"
      tooltip-effect="dark"
class="table xtable"
stripe
border
align="center"
highlight-current-row>
<el-table-column align="center" type="selection" width="55">
</el-table-column>
      <el-table-column
            align="center"
            prop="apply_number"
            show-overflow-tooltip
            label="保函编号"
            
          >
          </el-table-column>

          <el-table-column
            align="center"
            prop="username"
            show-overflow-tooltip
            label="付款人"
          
          >
          </el-table-column>

          <!-- <el-table-column align="center" prop="khsh " show-overflow-tooltip width="220" label="申请公司税号"> </el-table-column> -->
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="zftype"
        
            label="付款类型"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="money"
         
            label="支付金额"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="guarantee_company_name"
            width="160"
            label="出函机构名称"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="bankname"
          
            label="银行"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="bankcode"
         
            label="银行卡号"
          >
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="state"
          
            label="支付状态"
          >
            <!-- <template slot-scope="scope">{{
                scope.state ==0 ? "未支付" : "支付"
              }}</template> -->
            <template slot-scope="scope">{{
              scope.row.state == 0 ? "未支付" : "支付"
            }}</template>
          </el-table-column>
          <el-table-column
            align="center"
            show-overflow-tooltip
            prop="createtime"
           
            label="支付时间"
          >
            <template slot-scope="scope">{{
              scope.row.createtime | dateFormat
            }}</template>
          </el-table-column>
    </el-table>
      
          <!-- <el-table-column align="center" prop="createtime" width="220" label="分配时间"> </el-table-column> -->
          <!-- <el-table-column align="center" prop="createtime" label="创建时间" width="200">
      </el-table-column> -->
          <!-- <el-table-column
            fixed="right"
            align="center"
            width="120"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button size="mini" @click="handleUpdate(scope.row)"
            >添加步骤</el-button
          >
             <el-button size="mini" @click="buzhlist(scope.row)"
            >步骤列表</el-button
          >
              <el-button size="mini" @click="handleUpdate(scope.row)"
                >申请发票</el-button
              >
            </template>
          </el-table-column> -->

        <div class="block">
          <el-pagination
            background
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="limit"
          ></el-pagination>
        </div>
      </el-tab-pane>
      <el-tab-pane style="height: 100%" label="发票记录"> </el-tab-pane>
      <el-tab-pane style="height: 100%" label="快递记录"> </el-tab-pane>
      <el-tab-pane style="height: 100%" label="进度信息"> </el-tab-pane>
    </el-tabs>
    <!-- 放弃申请 -->
    <el-dialog
      title="放弃申请"
      :visible.sync="open"
      width="50%"
      :close-on-click-modal="false"
      v-dialogDrag
      custom-class="publicDialog"
    >
      <el-form ref="form" :model="formfqi" label-width="80px" class="">
        <el-form-item label="保函申请编号 :">
          <el-input disabled v-model="formfqi.apply_number"></el-input>
        </el-form-item>
        <el-form-item label="放弃原因 :">
          <el-input type="textarea" v-model="formfqi.apply_reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="" class="btn" @click="save">提交</el-button>
        <el-button type="" class="btn" @click="cancel">取消</el-button>
      </div>
    </el-dialog>
    <!-- 续保 -->
    <el-dialog
      title="续保"
      :visible.sync="open8"
      width="50%"
      append-to-body
      :close-on-click-modal="false"
      v-dialogDrag
      custom-class="publicDialog"
    >
      <el-form ref="form" :model="formsxu" label-width="120px">
        <el-form-item label="保函申请编号 :">
          <el-input disabled v-model="formsxu.apply_number"></el-input>
        </el-form-item>
        <!-- <el-form-item label="保函名称 :">
          <el-input v-model="forms.apply_name"></el-input>
        </el-form-item> -->
        <el-form-item label="申请事项 :">
          <el-input type="textarea" v-model="formsxu.apply_reason"></el-input>
        </el-form-item>
        <el-form-item label="续保金额 :">
          <el-input type="" v-model="formsxu.margin_amount"></el-input>
        </el-form-item>
        <el-form-item label="开始时间 :">
          <el-date-picker
            v-model="formsxu.begin_time"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间 :">
          <el-date-picker
            v-model="formsxu.end_time"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button @click="onSubmitXuBao" type="">提交</el-button>
        <el-button @click="open8 = false">取消</el-button>
      </div>
    </el-dialog>
    <!-- 解保申请 -->
    <el-dialog
      title="解保申请"
      :visible.sync="openj"
      width="50%"
      :close-on-click-modal="false"
      v-dialogDrag
      custom-class="publicDialog"
    >
      <el-form ref="form" :model="formsjb" label-width="80px" class="">
        <el-form-item label="保函申请编号 :">
          <el-input v-model="formsjb.apply_number"></el-input>
        </el-form-item>
        <el-form-item label="解保原因 :">
          <el-input type="textarea" v-model="formsjb.apply_reason"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="" class="btn" @click="saves">提交</el-button>
        <el-button type="" class="btn" @click="cancels">取消</el-button>
      </div>
    </el-dialog>
    <binad></binad>
  </div>
</template>

<script>
import binad from ".././../components/dinad.vue";
import hear from "@/components/hear.vue";

import { bhdetail } from "@/api/system/liucheng";
import { sapply } from "@/api/daihou.js";
import { apply, applys } from "@/api/daihou.js";
// import { snfiledown } from "@/api/xin.js";
export default {
  components: {
    hear,
    binad
  },
  data() {
    return {
      open: false, //放弃
      formfqi: {
        apply_number: "",
        apply_reason: "" //
      },

      open8: false, //续保
      formsxu: {
        apply_number: "",
        apply_reason: "",
        apply_name: "",
        margin_amount: "",
        begin_time: "",
        end_time: ""
      },
      openj: false, //解保
      formsjb: {
        apply_number: "",
        apply_reason: ""
      },
      formLabelAlign: {}, //申请公司信息
      chjg: {}, //出汗机构
      shenqingInfo: {}, //申请信息
      baohanFile: "", //保函文件
      shenqishenpiFilengInfo: "", //审批文件
      payList: "", //支付记录
      kdList: "", //快递记录
      applyno: "",
      tableData: [],
      limit: "",
      jinduInfo: {}, //进度信息
      url:
        "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg",
      srcList: [
        "https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg"
      ]
    };
  },
  created() {
    //   this.get_weidaili();
    //   this.get_daili();
    this.getDetail(this.$route.query.company_id);
  },
  methods: {
    // 续保申请
    xubao(val) {
      console.log("xubaoxub续保");
      this.formsxu = {
        apply_number: "",
        apply_reason: "",
        apply_name: "",
        margin_amount: "",
        begin_time: "",
        end_time: ""
      };
      this.open8 = true;
      this.formsxu.apply_number = this.shenqingInfo.apply_number;
    },
    //  续保申请 提交
    onSubmitXuBao() {
      console.log(this.formsxu);
      apply(this.formsxu).then(res => {
        console.log(res);
        if (res.data.code == 1) {
          this.open8 = false;
          // this.getWancheng();
          this.$message({
            message: res.data.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.data.msg
          });
        }
      });
    },
    jeibao() {
      (this.openj = true),
        (this.formsjb.apply_number = this.shenqingInfo.apply_number);
    },
    // 解保提交表单
    saves() {
      applys({ ...this.formsjb }).then(res => {
        console.log(res);
        if (res.data.code == 1) {
          this.open = false;
          // this.getList()
          this.$message({
            message: res.data.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.data.msg
          });
        }
      });
    },
    //解保
    cancels() {
      // this.reset()
      this.openj = false;
    },
    fanqi() {
      this.open = true;
      this.formfqi.apply_number = this.shenqingInfo.apply_number;
    },
    cancel() {
      // this.reset()
      this.open = false;
    },
    save() {
      sapply({ ...this.formfqi }).then(res => {
        console.log(res);
        if (res.code == 1) {
          this.open = false;
          // this.getList();
          this.$message({
            message: res.data.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.data.msg
          });
        }
      });
    },
    yulan(e) {
      this.$confirmMy({
        title: e
      });

      return;
      let link = document.createElement("a");
      link.style.display = "none";
      link.style.download = "";
      link.target = "_blank";
      link.href = e + "";
      // link.setAttribute("download", ".pdf");
      // +'.pdf' 通过不同的后缀名下载不同的文件
      //这里下载的是pdf格式的文件，拿到接口里的res也必须是pdf的文件流
      // document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(link.href); //URL.revokeObjectURL() 静态方法用来释放一个之前通过调用 URL.createObjectURL() 创建的已经存在的 URL 对象。当你结束使用某个 URL 对象时，应该通过调用这个方法来让浏览器知道不再需要保持这个文件的引用了。
      document.body.removeChild(link);
    },
    async xiazai(e) {
      let url = e; //  download(url)
      var bbc = {
        applyno: this.applyno,
        type: 0
      };
      const { data } = await snfiledown(bbc);
      this.xiazpdf(data.data);
    },
    xiazpdf(e) {
      var that = this;
      // res.data   就是后台返回的base64的 文件流
      let URL = this.dataURLtoBlob(e);
      var reader = new FileReader();
      reader.readAsDataURL(URL);
      reader.onload = function(e) {
        // 兼容IE
        if (window.navigator.msSaveOrOpenBlob) {
          var bstr = atob(e.target.result.split(",")[1]);
          var n = bstr.length;
          var u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr]);

          window.navigator.msSaveOrOpenBlob(blob, that.wenname);
        } else {
          // 转换完成，创建一个a标签用于下载
          var a = document.createElement("a");
          a.download = that.wenname;
          a.href = e.target.result;
          a.setAttribute("id", "export");
          document.getElementById("purchaseManage").append(a); // 修复firefox中无法触发click
          a.click();
          document.getElementById("export").remove();
        }
      };
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    dataURLtoBlob(dataurl) {
      var bstr = atob(dataurl);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: "pdf" });
    },
    // 获取详情
    getDetail(id) {
      bhdetail({
        apply_number: id
      }).then(res => {
        console.log("详情", res.data.data);
        this.shenqingInfo = res.data.data.jiben;
        // console.log("shenqingInfo",this.shenqingInfo);
        this.formLabelAlign = res.data.data.shenqing_company;
        this.shenqishenpiFilengInfo = res.data.data.ziliao;
        this.baohanFile = res.data.data.enclosure;
        this.baohanFile.push({
          filename: "担保协议",
          qz_file: res.data.data.xieyi.file
        });
        this.baohanFile.push({
          filename: "保函文件",
          qz_file: res.data.data.baohanwenjian
        });
        //
        if (res.data.data.jiben.gtype !== "投标保函") {
          this.baohanFile.push({
            apply_number: res.data.data.enclosure[0].apply_number,
            baohanname: res.data.data.enclosure[0].baohanname,
            filename: "反担保协议书",
            qz_file: res.data.data.fandanbaowenjian
          });
        }

        this.chjg = res.data.data.guarantee_company;
        this.tableData.push(res.data.data.pay);
        this.limit = 1;
        console.log("支付记录", this.tableData);
        // this.kdList = res.data.data.kuaidi;
        // this.applyno = res.data.data.jiben.apply_number
      });
    }
  }
};
</script>
<style scoped lang="scss">
.weidaili_head {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.search {
  float: right;
  width: 20%;
  height: 40px;
  border: 1px solid #ccc;
  border-radius: 5px;
  display: flex;

  ::v-deep.el-input__inner {
    border: none !important;
  }

  .el-button {
    border: none;
  }
}

::v-deep.el-input__inner {
  border: none !important;
}

.weidaili {
  height: 75vh;
  margin-bottom: 10px;
  overflow: hidden;
}

.block {
  width: 95%;
  padding: 10px;

  display: flex;
  justify-content: flex-end;
}

.showphoto {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.showphoto1 {
  height: 553px;
  background: #f5f6fa;
  border-radius: 4px 4px 4px 4px;
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-tabs .el-tab-pane {
  height: 100%;
  display: flex;
  padding-right: 10px;
  flex-direction: column;
  justify-content: space-between;
  // overflow-y: auto;
}

.app-container {
  //   height: calc(100vh + 50px);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  position: relative;
  // display: flex;
  // flex-direction: column;
  // position: relative;
}

// ::v-deep .el-tabs__content {
//   // height: 100% !important;
// }

.public-ku {
  margin-top: 1.375rem;
  width: 443.8px;
  height: 250px;
  margin-bottom: 1.25rem;
}

.kuang-txt {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
}

.pdf {
  width: 50px;
  height: 50px;
}

.kuang-1 {
  font-size: 1.1625rem;
  line-height: 2.3125rem;
  margin-left: 1.25rem;
  margin-top: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: 800;
  color: #333333;
}

.fromsBox {
  width: 100%;
  overflow: auto;
  /* margin: 0px auto; */
  margin-top: 60px;
  padding: 0 15%;
  padding-bottom: 40px;

  .el-form-item {
    margin-bottom: 4px;
    margin-left: 20px;
  }
}

.title {
  font-weight: bold;
  margin-bottom: 10px;
}

.left {
  width: 70%;
  margin: 0px auto;
  margin-top: 60px;
}

.conter {
  margin-left: 20px;
  // width: 85%;
}

.backoff {
  position: absolute;
  z-index: 999;
  left: 222px;
  top: 77px;
  // top: 83px;
  // margin-left: 180px;
  display: flex;
  justify-content: flex-end;
  padding: 5px 0;
  box-sizing: border-box;

  div {
    width: calc(100vw - 240px);
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
  }

  .el-button {
    border: 1px solid;
  }
}

.rzBox {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%);

  .el-button {
    width: 150px !important;
  }
}

.renzhng {
  flex: 1;
  overflow-y: auto;
  padding: 0 10%;

  .el-form-item {
    margin-bottom: 4px;
  }
}

.footer {
  display: flex;
  padding-left: 10px;
  box-sizing: border-box;
  height: 45px;
  // justify-content: center;
  align-items: center;
  background-color: #f4f4f5 !important;

  .btn {
    width: 80px;
    height: 35px;
    border: 1px solid #1795ff;
  }
}

.table {
  margin-top: 50px;
  
}

.public-kuang {
  margin-top: 0.5rem;
  //   width: 750px;
  height: 85px;
  padding: 0.5125rem 0.55rem;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;

  //   flex-direction: column;
  /* justify-content: space-between; */
  /* align-items: center; */
  background: #ffffff;
  -webkit-box-shadow: 0rem 0rem 0.1875rem 0rem rgb(0 0 0 / 15%);
  box-shadow: 0rem 0rem 0.1875rem 0rem rgb(0 0 0 / 15%);
}

.kuang-txt {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-weight: 800;
}

.kuang-1 {
  font-size: 1.1625rem;
  line-height: 2.3125rem;
  margin-left: 1.25rem;
  margin-top: 0.375rem;
  font-family: Microsoft YaHei;
  font-weight: 800;
  color: #333333;
}

.kuang-2 {
  width: 4.125rem;
  height: 2.0375rem;
  line-height: 1.375rem;
  text-align: center;
  /* border-radius: 20px; */
  background: #069cff;
  border: 0.0625rem solid #069cff;
  font-size: 1rem;
  font-family: Microsoft YaHei;
  font-weight: 400;
  padding: 0.3125rem 0.5125rem;
  color: #fff;
}

.tac {
  height: 100%;
}

::v-deep .tac .el-tabs__content {
  height: 100%;
  overflow-y: auto;
}
::v-deep .el-tabs--left .el-tabs__item.is-left {
  width: 200px;
  height: 50px;
  line-height: 50px;
  text-align: end;
  font-size: 18px;
  font-family: MicrosoftYaHei-, MicrosoftYaHei;
  font-weight: normal;
  color: #000000;
}

::v-deep .fromsBox .el-input__inner {
  width: 100% !important;
}
::v-deep .el-tabs--left .el-tabs__item.is-active {
  background: #1795ff;
  color: #fff;
}
::v-deep .el-tabs--left {
  height: 100%;
}
::v-deep .el-tabs__item {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/agencies/bhxq.vue